import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonJourneysRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/journeys/:subjectId` — the address the embedded app links a journey
 * to. It forwards to the journey's own URL once the rollout flag is on, and renders the embedded app
 * in place while it is off.
 */
function JourneysPersonJourneyRoute() {
  const { personId, subjectId } = Route.useParams();

  return <JourneysPersonJourneysRoute personId={personId} subjectId={subjectId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/$subjectId',
)({
  component: JourneysPersonJourneyRoute,
});
